/* eslint-disable global-require */
const cloudSourcesConfig = {
  google_adwords: {
    report: require('./google_adwords/reports.json'),
  },
  netsuite: {
    saved_search: require('./netsuite/saved_search.json'),
    custom_record: require('./netsuite/custom_record.json'),
  },
};

export default cloudSourcesConfig;
